import { css, Theme } from '@emotion/react'
import { Box, Typography } from '@mui/material'

import FeatureCardForService from '../molecules/FeatureCardForService'
import { returnFeed } from '~/utils/returnFeed'

type Props = {
  title: string
  strength: {
    index: string
    title: string
    description: string
    src: string
  }[]
}

const Features: React.FC<Props> = ({ title, strength }) => {
  return (
    <Box css={styles.wrapper}>
      <Box css={styles.container} component='section'>
        <Box css={styles.head}>
          <Typography variant='h1' css={styles.title} color='primary'>
            {title}
          </Typography>
        </Box>
        <Box component='ul' css={styles.cardContainer}>
          {strength.map(({ index, title, description, src }) => (
            <li css={styles.listItem} key={index}>
              <FeatureCardForService
                index={index}
                title={returnFeed(title)}
                description={description}
                src={src}
              />
            </li>
          ))}
        </Box>
      </Box>
    </Box>
  )
}

const styles = {
  wrapper: css`
    width: 100vw;
  `,
  container: css`
    max-width: 1180px;
    margin: 0 auto;
  `,
  head: css`
    padding: 40px 60px;
    @media (max-width: 768px) {
      padding: 40px 20px;
    }
  `,
  title: css`
    font-family: 'Noto sans JP', sans-serif;
    font-size: 3rem;
    font-weight: 700;
    margin: 4rem 2rem 6rem;
    padding-left: 40px;
    border-left: 8px solid #0d9bbe;
    @media (max-width: 960px) {
      font-size: 2.1rem;
    }
    @media (max-width: 768px) {
      padding-left: 20px;
      margin: 0rem 0rem 2rem;
      font-size: 1.6rem;
    }
  `,
  cardContainer: css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
    padding-inline-start: 0;
    margin-block-start: 0;
    margin-block-end: 0;
  `,
  listItem: css`
    list-style: none;
  `,
}

export default Features
